/** Where the event detail screen should land when opened from the events list. */
export type EventStatusLandingTab = 'first_tab' | 'draws_results';

export const event_status: ReadonlyArray<{
  title: string;
  value: number;
  class_name: string;
  landingTab: EventStatusLandingTab;
}> = [
    { title: 'REGISTRATION OPEN', value: 1, class_name: 'Registration Open', landingTab: 'first_tab' },
    { title: 'REGISTRATION CLOSED', value: 2, class_name: 'Registration Closed', landingTab: 'first_tab' },
    { title: 'DRAWS IN MAKING', value: 3, class_name: 'Draws In Making', landingTab: 'first_tab' },
    { title: 'DRAWS OUT', value: 4, class_name: 'Draws Out', landingTab: 'draws_results' },
    { title: 'CANCELLED', value: 5, class_name: 'Cancelled', landingTab: 'first_tab' },
    { title: 'RESCHEDULED', value: 6, class_name: 'Rescheduled', landingTab: 'first_tab' },
    { title: 'STATUS 7', value: 7, class_name: 'Status 7', landingTab: 'first_tab' },
    { title: 'PENDING', value: 8, class_name: 'Pending', landingTab: 'first_tab' },
    { title: 'VERIFIED', value: 9, class_name: 'Verified', landingTab: 'first_tab' },
    { title: 'REJECTED', value: 10, class_name: 'Rejected', landingTab: 'first_tab' },
    { title: 'UNVERIFIED', value: 11, class_name: 'Unverified', landingTab: 'first_tab' },
    { title: 'INCOMPLETE', value: 12, class_name: 'Incomplete', landingTab: 'first_tab' },
    { title: 'ONGOING', value: 13, class_name: 'Ongoing', landingTab: 'draws_results' },
    { title: 'UPCOMING', value: 14, class_name: 'Upcoming', landingTab: 'first_tab' },
    { title: 'RECENT', value: 15, class_name: 'Recent', landingTab: 'draws_results' },
];

/** Visual tone of an event status — drives the event card badge and the map pin colors. */
export type EventStatusTone = 'open' | 'closed' | 'cancelled' | 'ongoing' | 'draws' | 'upcoming' | 'muted';

/** Keyed by `event_status` value; unlisted statuses fall back to 'muted'. */
export const EVENT_STATUS_TONE_BY_VALUE: Readonly<Record<number, EventStatusTone>> = {
    1: 'open',
    2: 'closed',
    3: 'upcoming',
    4: 'draws',
    5: 'cancelled',
    6: 'upcoming',
    13: 'ongoing',
    14: 'upcoming',
};

export function eventStatusTone(value: unknown): EventStatusTone {
    return EVENT_STATUS_TONE_BY_VALUE[Number(value)] ?? 'muted';
}

export const tournament_Type=[
    {id:1,title:"National"},
    {id:2,title:"International"},

]

export const filtered_schedule_tabs=[
    {id:1,title:"Scheduled"},
    {id:2,title:"Unscheduled"}
]